<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BdYQ3e/tc-custom/9781480433885.jpg?1701883865215" alt="This image is the cover for the book Quin's Shanghai Circus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quin's Shanghai Circus
      </h1>
      <p class="bookDescription body article font2">
        <b>In Edward Whittemore’s masterful and surreal alternate history, a man’s search for answers about his vanished parents propels him on an odyssey from the present into the past, from a bar in the Bronx to Tokyo and Shanghai during the Second World War </b><br/>Quin, born in China and raised in the Bronx, is orphaned in the closing days of the Second World War when his parents go missing and are presumed dead in Shanghai. Years later, in a Bronx bar, Quin encounters a stranger who hints that he can uncover the secrets of his past by accompanying Big Gobi, an adult orphan too simpleminded to travel alone, on a journey to meet his guardian in Tokyo. Quin arrives in Japan determined to uncover the truth about his parents’ past, but his search soon raises more questions than answers. What are the connections between a Russian anarchist, a one-eyed baron who is head of the Japanese secret service known as the Kempeitai, and the atrocities committed during the rape of Nanking? And what does any of it have to do with Quin’s parents?<br/>Part espionage novel and part surreal fantasy, <i>Quin’s Shanghai Circus</i>, the first novel by Edward Whittemore, is a remarkable and audacious literary feat. Alive with a fascinating cast of characters and equally enthralling turns of events, former CIA officer Whittemore offers readers a mesmerizing glimpse at a secret history of the twentieth century.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Whittemore
      </h2>
      
      <p class="authorDescription body article">Edward Whittemore (1933&shy;&shy;&shy;&ndash;1995) graduated from Yale University in 1955 and went on to serve as a Marine officer in Japan and spend ten years as a CIA operative in the Far East, Europe, and the Middle East. In addition to writing fiction, he managed a newspaper in Greece, was employed by a shoe company in Italy, and worked in New York City&rsquo;s narcotics control office during the administration of Mayor John V. Lindsay. He wrote the Jerusalem Quartet while dividing his time between New York and Jerusalem.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ddb29ec